import ACTIONS, { FETCH_STATUS } from "../constants";

export const getRiskAttempt = {
  pending: {
    type: ACTIONS.RISK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RISK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RISK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getRisk = (state) => ({
  type: ACTIONS.RISK_CALL,
  payload: state,
});

export const createRiskAttempt = {
  pending: {
    type: ACTIONS.CREATE_RISK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_RISK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_RISK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createRiskRequest = (state) => ({
  type: ACTIONS.CREATE_RISK_CALL,
  payload: state,
});

export const updateRiskAttempt = {
  pending: {
    type: ACTIONS.UPDATE_RISK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_RISK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_RISK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateRiskRequest = (state) => ({
  type: ACTIONS.UPDATE_RISK_CALL,
  payload: state,
});

export const deleteRiskAttempt = {
  pending: {
    type: ACTIONS.DELETE_RISK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_RISK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_RISK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteRiskRequest = (state) => ({
  type: ACTIONS.DELETE_RISK_CALL,
  payload: state,
});

export const sortRiskAttempt = {
  pending: {
    type: ACTIONS.SORT_RISKS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_RISKS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_RISKS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortRiskRequest = (state) => ({
  type: ACTIONS.SORT_RISKS_CALL,
  payload: state,
});

export const updateRiskFlagAttempt = {
  pending: {
    type: ACTIONS.RISK_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RISK_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RISK_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateRiskFlag = (state) => ({
  type: ACTIONS.RISK_FLAG_CALL,
  payload: state,
});
